import * as S from './Overlay.styled'

export const Overlay = ({ children, ...props }) => (
  <S.Overlay {...props}>{children}</S.Overlay>
)

export default Overlay
